import { createRoot } from "react-dom/client";

import init, { Game } from "../pkg";
import { App } from "./components/App";

export const width = 160;
export const height = 120;

async function run() {
    await init();

    const game = new Game(width, height);

    const root = createRoot(document.getElementById("app-root"));
    root.render(<App game={game} />);
}

void run();
